import { render, staticRenderFns } from "./addWx.vue?vue&type=template&id=c6eab7e8&scoped=true&"
import script from "./addWx.vue?vue&type=script&lang=js&"
export * from "./addWx.vue?vue&type=script&lang=js&"
import style0 from "./addWx.vue?vue&type=style&index=0&id=c6eab7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6eab7e8",
  null
  
)

export default component.exports